import { endOfComment } from "./end-of-comment";
import { endOfStringLiteral } from "./end-of-string-literal";

/**
 * Index of the last character of the string or comment at `at`, or `at` if
 * neither. Strings and comments only: a regex literal is not recognised.
 */
export function endOfSkippable(source: string, at: number): number {
  const char = source[at];
  if (char === "'" || char === '"' || char === "`") {
    return endOfStringLiteral(source, at);
  }
  return endOfComment(source, at);
}
